@import '~style-sheet-helpers/core.less';
@import '../app-brand/entities/entity-layer.module.less';

footer {
  margin-top: 20px;
  padding-top: 10px;
  border-top: 1px solid @authentication--footer--border-color;
  height: 60px;
  display: flex;
  flex-flow: row wrap;
  place-content: space-between space-between;
  a:first-child {
    margin: 0 40px 0 0;
    color: @authentication--footer--text-color;
  }
  a.change-password {
    margin: 0 95px 0 0;
  }
}

.auth-form {
  color: @authentication--text-color;
  margin: 0 auto;
  width: 300px;
  min-height: 200px;
  padding-top: 10px;
}

.wider-auth-form {
  width: 385px;
}

.auth-form-title {
  text-align: center;
  margin-bottom: 10px;
  font-size: 20px;
}

.auth-form-instructions {
  text-align: center;
  margin-bottom: 10px;
  font-size: 14px;
}

.auth-fine-print {
  display: flex;
  font-size: 14px;
  line-height: 18px;
}

.auth-agreement {
  margin-right: 5px;
}

.auth-button {
  height: 44px;
  width: 100%;
  margin-top: 10px;
  border-radius: 4px;
  background-color: @authentication--button--background-color;
  box-shadow: inset 0 -1px 0 0 @authentication--button--box-shadow-color;
  font-size: 15px;
  line-height: 18px;
}

.auth-textfield {
  margin: 0 0 10px;
}

.text-link {
  display: flex;
  color: @authentication--link--text-color;
}

.error-message,
.success-message {
  margin-top: 15px;
  color: @authentication--message--error--text-color;
  font-size: 13px;
  line-height: 15px;
}
.success-message {
  color: @authentication--message--success--text-color;
}
